// Module
var code = "<div nlg-portlet> <div nlg-portlet-title> <nlg-tdn-help-title page-icon=\"glyphicon glyphicon-globe\" page-title=menu.report.bi context=context tdn=tdn> </nlg-tdn-help-title> <nlg-micro-strategy></nlg-micro-strategy> </div> </div>";
// Exports
module.exports = code;